import { render, staticRenderFns } from "./PositionSelector.vue?vue&type=template&id=1aa61867&scoped=true&"
import script from "./PositionSelector.vue?vue&type=script&lang=js&"
export * from "./PositionSelector.vue?vue&type=script&lang=js&"
import style0 from "./PositionSelector.vue?vue&type=style&index=0&id=1aa61867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa61867",
  null
  
)

export default component.exports